import tw from 'tailwind-styled-components';
import { ArrowLeft } from 'styled-icons/heroicons-outline';
import { useRouter } from 'next/router';

import Link from '@/components/link';

const BackArrow = tw(ArrowLeft)`
  mr-2
  h-5
  w-5
`;

const Container = tw(Link)`
  inline-flex
  items-center
  text-slate-700
  no-underline
`;

const A = tw.a`
  inline-flex
  items-center
  text-slate-700
  no-underline
`;

const BackLink = ({ children, href, ...rest }) => {
  const router = useRouter();
  const textContent = children || 'Back';

  const handleClick = event => {
    event.preventDefault();
    router.back();
  };

  if (!href) {
    return (
      <A href="#" onClick={handleClick}>
        <BackArrow strokeWidth={2} />
        {textContent}
      </A>
    );
  }

  return (
    <Container href={href} {...rest}>
      <BackArrow strokeWidth={2} />
      {textContent}
    </Container>
  );
};

export default BackLink;
